export default __webpack_public_path__ + "static/media/slide1.05fcff5d.jpg";